import { socialCrawlerApiClient } from '../client';

export function getIndustries(entityId) {
  return socialCrawlerApiClient
    .get('/industry/list', {
      params: {
        entityId,
      },
    })
    .then(({ data }) => data);
}
